import { stripHtml } from '@/utils';

export default class Grouping {
  constructor(obj) {
    this.id = obj.id;
    this.name = obj.name;
    this.groupingType = obj.groupingType;
    this.completionTime = obj.completionTime;
    this.assetAssociations = obj.assetAssociations;
    this.productAssociations = obj.productAssociations;

    this._categoryIds = undefined;
  }

  get assetTitle() {
    let title = this.name || 'Grouping';
    return stripHtml(title);
  }

  get assetType() {
    return 'Grouping';
  }

  get categoryIds() {
    if (this._categoryIds) {
      return this._categoryIds;
    }

    const catIds = this.productAssociations.map(pa => pa.categoryId).filter(pa => pa);
    this._categoryIds = catIds;
    return catIds;
  }

  get flashcardAssociations() {
    return this.sortedAssetAssociations.filter(aa => aa.assetBType === 'V3Flashcard');
  }

  get route() {
    return {
      name: 'groupings#show',
      params: {
        groupingId: this.id,
      },
    };
  }

  get sortedAssetAssociations() {
    return [...(this.assetAssociations || [])].sort((a, b) => a.order - b.order);
  }

  cardMetadata() {
    return `${this.assetAssociations.length} Items`;
  }

  categoryOrder(categoryId) {
    let productAssoc;
    if (Array.isArray(categoryId)) {
      productAssoc = this.productAssociations.find(pa => categoryId.includes(pa.categoryId));
    } else {
      productAssoc = this.productAssociations.find(pa => pa.categoryId == categoryId);
    }
    return productAssoc?.order;
  }

  difficultyLabel(store) {
    // if (this.difficultyLowerBound) {
    //   const allLevels = store.getters['difficultyLevels/all'];
    //   const level = allLevels.find(l => l.difficultyLevel == this.difficultyLowerBound);
    //   return level?.label;
    // }
    //
    // This is a placeholder until difficulty level exists on all asset types
    return false;
  }

  // Dummy methods as a fallback for groupings with types
  // Should only be temporary as groupings are transitioned to other types
  completedState() {
    return false;
  }

  inProgressState() {
    return false;
  }

  states() {
    return [];
  }
}
